const commentSection = (editor) => {

    editor.BlockManager.add('commentSection', {
        category: 'Built In Components',
        label: 'Comment Section',
        attributes: {},
        content: `
        <div class="row d-flex justify-content-center m-4">
          <div class="col-md-8 col-lg-6">
            <div class="card shadow-0 border bg-light" dataItems="getAllCards">
              <div class="card-body p-4">
                <div class="form-outline mb-4">
                  <input type="text" id="addANote" class="form-control" placeholder="Type comment..." />
                  <label class="form-label d-none" for="addANote">+ Add a note</label>
                  <div class="d-flex justify-content-end pt-3">
                    <button type="button" class="btn btn-success btn-md ms-2">Add Comment</button>
                  </div>
                </div>
        
                <div class="card mb-4" dataitem=true>
                  <div class="card-body shadow">
                    <p dataCardDescription=true>Type your note, and hit enter to add it</p>
        
                    <div class="d-flex justify-content-between">
                      <div class="d-flex flex-row align-items-center">
                        <img dataCardImage=true src="https://cdn.pixabay.com/photo/2017/03/01/22/18/avatar-2109804_640.png" alt="avatar" width="25"
                          height="25" />
                        <p class="small mb-0 ms-2" dataCardTitle=true>Martha</p>
                      </div>
                      <div class="d-flex flex-row align-items-center">
                        <p class="small text-muted mb-0">Upvote?</p>
                        <i class="bi-hand-thumbs-up mx-2 text-black" style="margin-top: -0.16rem;"></i>
                        <p class="small text-muted mb-0" dataCardButton=true>3</p>
                      </div>
                    </div>
                  </div>
                </div>
        
                <div class="card mb-4" dataitem=true>
                  <div class="card-body shadow">
                    <p dataCardDescription=true>Type your note, and hit enter to add it</p>
                    
        
                    <div class="d-flex justify-content-between">
                      <div class="d-flex flex-row align-items-center">
                        <img dataCardImage=true src="https://cdn.pixabay.com/photo/2017/02/23/13/05/avatar-2092113_640.png" alt="avatar" width="25"
                          height="25" />
                        <p class="small mb-0 ms-2" dataCardTitle=true>Johny</p>
                      </div>
                      <div class="d-flex flex-row align-items-center">
                        <p class="small text-muted mb-0">Upvote?</p>
                        <i class="bi-hand-thumbs-up mx-2 text-black" style="margin-top: -0.16rem;"></i>
                        <p class="small text-muted mb-0" dataCardButton=true>4</p>
                      </div>
                    </div>
                  </div>
                </div>
        
                <div class="card mb-4" dataitem=true>
                  <div class="card-body shadow">
                    <p dataCardDescription=true>Type your note, and hit enter to add it</p>
        
                    <div class="d-flex justify-content-between">
                      <div class="d-flex flex-row align-items-center">
                        <img dataCardImage=true src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359554_640.png" alt="avatar" width="25"
                          height="25" />
                        <p class="small mb-0 ms-2" dataCardTitle=true>Mary Kate</p>
                      </div>
                      <div class="d-flex flex-row align-items-center text-primary">
                        <p class="small mb-0">Upvoted</p>
                        <i class="bi-hand-thumbs-up mx-2 " style="margin-top: -0.16rem;"></i>
                        <p class="small mb-0" dataCardButton=true>2</p>
                      </div>
                    </div>
                  </div>
                </div>
        
                <div class="card" dataitem=true>
                  <div class="card-body shadow">
                    <p dataCardDescription=true>Type your note, and hit enter to add it</p>
        
                    <div class="d-flex justify-content-between">
                      <div class="d-flex flex-row align-items-center">
                        <img dataCardImage=true src="https://cdn.pixabay.com/photo/2017/02/23/13/05/avatar-2092113_640.png" alt="avatar" width="25"
                          height="25" />
                        <p class="small mb-0 ms-2" dataCardTitle=true>Johny</p>
                      </div>
                      <div class="d-flex flex-row align-items-center">
                        <p class="small text-muted mb-0">Upvote?</p>
                        <i class="bi-hand-thumbs-up mx-2 text-black" style="margin-top: -0.16rem;"></i>
                        <p class="small mb-0" dataCardButton=true>1</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        `
    })
};

export default commentSection;